<template>
  <div>
    <base-text-input
      :value="value"
      @input="input"
      v-on="listeners"
      :type="isPassVisible ? 'text' : 'password'"
      :icon="isPassVisible ? 'visibility-on' : 'visibility-off'"
      :preloadIcons="['visibility-on', 'visibility-off']"
      :iconClick="togglePassVisible"
      :rules="rules"
      :name="name"
      :label="label"
      v-bind="attrs"
      :noFocus="rules.includes('entropy')"
      :autofocus="autofocus"
    />
    <div :class="$style.meterContainer" v-if="rules.includes('entropy')">
      <div :class="$style.meter">
        <div
          :class="$style.bar"
          :style="{ backgroundColor, boxShadow, width }"
        />
      </div>
      <div :class="$style.message">
        {{ entropyMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import stringEntropy from 'fast-password-entropy'

import config from '@/services/config'

export default {
  name: 'base-password-input',

  props: {
    value: { String },
    placeholder: { String },
    autofocus: { Boolean, default: false },
    disabled: { Boolean, default: false },
    name: { String, required: true },
    label: { String, required: true },
    rules: { String }
  },

  data: () => ({
    isPassVisible: false
  }),

  computed: {
    entropy() {
      return stringEntropy(this.value)
    },

    entropyRatio() {
      return this.entropy / config.minEntropy
    },

    entropyMessage() {
      if (this.entropyRatio >= 1 && this.entropyRatio < 1.5) return 'Strong'
      if (this.entropyRatio >= 1.5) return 'Very strong'
      return ''
    },

    width() {
      return `${Math.min(this.entropyRatio * 100, 100)}%`
    },

    hue() {
      // Hues are adapted to match the theme's success and danger colors
      const orangeHue = 50
      const greenHue = 139
      const redHue = 11

      return this.entropyRatio < 1
        ? this.entropyRatio * orangeHue + redHue
        : greenHue
    },

    backgroundColor() {
      return `hsl(${this.hue}, 62%, 55%)`
    },

    boxShadow() {
      return this.entropyRatio >= 1
        ? `0 0 10px hsla(${this.hue}, 100%, 50%, 1)`
        : 'none'
    },

    listeners() {
      const { ...listeners } = this.$listeners
      return listeners
    },

    attrs() {
      return this.$attrs
    }
  },

  methods: {
    input(event) {
      this.$emit('input', event)
    },

    togglePassVisible() {
      this.isPassVisible = !this.isPassVisible
    }
  }
}
</script>

<style lang="scss" module>
.meterContainer {
  margin-bottom: spacing(2);
  margin-top: spacing(-4.5);
  position: relative;
  z-index: 1;
}

.meter {
  height: 2px;
}

.bar {
  height: 2px;
  transition: 0.5s;
}

.message {
  font-size: $size-xx-small;
  font-weight: $weight-medium;
  line-height: $size-medium;
  letter-spacing: 0.4px;
  color: $color-success;
  min-height: spacing(2);
  padding-left: spacing(2);
  margin-top: 2px;
  text-align: left;
}
</style>
